import React from "react";
import { Collapse as AntCollapse } from "antd";
import { CollapseProps as AntCollapseProps } from "antd/lib/collapse";

const Collapse: React.FC<AntCollapseProps> = (props) => {
  return <AntCollapse {...props} />;
};

export default Collapse;
